import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import DP, { registerLocale } from "react-datepicker";
import { enUS, ru } from "date-fns/locale";
import { clearDate } from "@utils";
import CalendarIcon from "@assets/icon_calendar.svg";
import { useAppDispatch, useAppSelector } from "@hooks";
import { showNotification } from "@store";
import { fields } from "./localization";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.scss";
const MIN_YEAR = 1900;
export function DatePicker({ disabled, hasError, showMonthYearPicker, className, placeholderText, value, onChange, }) {
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const calendarBtnRef = useRef();
    const [innerDate, setInnerDate] = useState(value === null || value === undefined || (value === null || value === void 0 ? void 0 : value.getFullYear()) >= MIN_YEAR ? value : new Date());
    const [innerValue, setInnerValue] = useState("");
    const [hasInnerDateError, setHasInnerDateError] = useState(false);
    const { language } = useAppSelector((state) => state.ui);
    const dispatch = useAppDispatch();
    const field = fields(language);
    const isValid = (str) => {
        if (!str || !/^[\d/]+$/.test(str) || str.length > 7 || str.length < 6) {
            return false;
        }
        const match = /^([\d]{1,2})(\/{1})([\d]{4})/.exec(str);
        if (match) {
            const year = Number(match[3]);
            const monthNumber = Number(match[1]);
            const currentDate = new Date();
            if (year < MIN_YEAR || year > currentDate.getFullYear()) {
                return false;
            }
            return !(monthNumber < 1 || monthNumber > 12);
        }
        return false;
    };
    useEffect(() => {
        setInnerDate(value);
        if (value === null || value === undefined) {
            setInnerValue("");
            setHasInnerDateError(false);
            if (value === undefined) {
                setHasInnerDateError(true);
            }
        }
        else {
            const calculatedValue = `${value.getMonth() + 1 < 10 ? "0" : ""}${value.getMonth() + 1}/${value.getFullYear()}`;
            if (isValid(calculatedValue)) {
                setHasInnerDateError(false);
                setInnerValue(calculatedValue);
            }
            else {
                onChange(undefined);
                dispatch(showNotification({ isSuccess: false, message: field.emptyDate }));
                setHasInnerDateError(true);
            }
        }
    }, [value]);
    const handleOutsideClick = (event) => {
        onChange(innerDate);
        if (isCalendarOpen && !calendarBtnRef.current.contains(event.target)) {
            setIsCalendarOpen(false);
        }
    };
    const handleInputChange = (event) => {
        setIsCalendarOpen(false);
        let str = event.target.value;
        if (str === "") {
            setInnerValue("");
            return;
        }
        if (!str || !/^[\d/]+$/.test(str) || str.length > 7) {
            return;
        }
        if (/^\d\d$/.exec(str) && !/^\d\d\/$/.exec(innerValue)) {
            str = `${str}/`;
        }
        setInnerValue(str);
        if (!str || str.length < 6) {
            setHasInnerDateError(true);
            return;
        }
        const match = /^([\d]{1,2})(\/{1})([\d]{4})/.exec(str);
        if (match) {
            const year = Number(match[3]);
            const monthNumber = Number(match[1]);
            const newDate = new Date(year, monthNumber - 1);
            const currentDate = new Date();
            if (year < MIN_YEAR ||
                year > currentDate.getFullYear() ||
                (monthNumber > currentDate.getMonth() && year >= currentDate.getFullYear())) {
                setHasInnerDateError(true);
            }
            else if (monthNumber < 1 || monthNumber > 12) {
                setHasInnerDateError(true);
            }
            else {
                setInnerDate(newDate);
                setHasInnerDateError(false);
                onChange(newDate);
            }
        }
        else {
            setHasInnerDateError(true);
        }
    };
    registerLocale("ru", ru);
    registerLocale("en", enUS);
    return (React.createElement("div", { className: clsx(className, "datepicker-wrap", (hasError || hasInnerDateError) && "error") },
        React.createElement(DP, { disabled: disabled, selected: innerDate, value: innerValue, onChangeRaw: handleInputChange, onChange: (date) => {
                setHasInnerDateError(false);
                if (date) {
                    onChange(new Date(clearDate(date.toISOString())));
                }
                else {
                    onChange(undefined);
                }
            }, open: isCalendarOpen, minDate: new Date(`01/01/${MIN_YEAR}`), maxDate: new Date(), dateFormat: showMonthYearPicker ? "MM/yyyy" : "dd/MM/yyyy", placeholderText: placeholderText, onInputClick: () => setIsCalendarOpen(!isCalendarOpen), onClickOutside: handleOutsideClick, showYearDropdown: true, dropdownMode: "select", showMonthYearPicker: showMonthYearPicker, locale: field.locale, shouldCloseOnSelect: true, autoComplete: "off" }),
        React.createElement("button", { className: "datepicker__calendar-icon-box", type: "button", ref: calendarBtnRef, disabled: disabled, onClick: () => {
                if (!disabled) {
                    setIsCalendarOpen(!isCalendarOpen);
                }
            } },
            React.createElement(CalendarIcon, { className: "datepicker__calendar-icon" }))));
}
